import { AthleteResultItem } from "../types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { PersonIcon } from "@navikt/aksel-icons";

const AthleteCard = (props: AthleteResultItem) => {
  const {
    club,
    name,
    team,
    jobTitle,
    phonenumber,
    email,
    profileImage,
    photoCredit,
    fisAthleteId,
    fisAthleteSectorValue,
  } = props;

  return (
    <Card
      key={name}
      className="flex flex-col items-center gap-5 rounded-none md:flex-row athleteCard"
    >
      <Card.Block className="flex flex-col w-full gap-[7px] p-0">
        <Heading className="heading-sm mb-0 text-neutralNsf">{name}</Heading>
        {club.title && club.url && (
          <Paragraph>
            Klubb:{" "}
            <Link href={club.url} className="text-blue-600 hover:underline">
              {" "}
              {club.title}{" "}
            </Link>
          </Paragraph>
        )}
        {jobTitle && <Paragraph>Stilling: {jobTitle}</Paragraph>}
        {team && <Paragraph>Lag: {team}</Paragraph>}

        {phonenumber && <Paragraph>Telefon: {phonenumber}</Paragraph>}
        {email && <Paragraph>E-post: {email}</Paragraph>}
        {fisAthleteId !== 0 && (
          <Paragraph>FIS utøver-ID: {fisAthleteId}</Paragraph>
        )}
        {fisAthleteSectorValue && (
          <Paragraph>FIS utøver sektorverdi: {fisAthleteSectorValue}</Paragraph>
        )}
      </Card.Block>
      {profileImage.url ? (
        <Card.Block className="athleteImg">
          <img
            src={profileImage.url}
            alt={profileImage.altText || photoCredit}
          />
        </Card.Block>
      ) : (
        <Card.Block className="athleteImg">
          <PersonIcon aria-hidden="true" fontSize="6rem" />
        </Card.Block>
      )}
    </Card>
  );
};

export default AthleteCard;
